export const PAY_FLOWS = {
    PAY: 'pay',
    PAY_AND_SAVE: 'payAndSave',
    TOKENIZE: 'tokenize',
};

export const PAYPAL_ENV = {
    SANDBOX: 'sandbox',
    PRODUCTION: 'production',
};

export const PAYPAL_FUNDING_SOURCES = {
    PAYPAL: 'paypal',
    CREDIT: 'credit',
    PAY_LATER: 'pay_later',
};

export const PAYPAL_NAME_SPACES = {
    PAYPAL: 'paypal',
    PAYPAL_CREDIT: 'paypal_credit',
    PAY_LATER: 'paypal_pay_later',
};

export const PAYPAL_FLOWS = {
    CHECKOUT: 'checkout',
    VAULT: 'vault',
};

export const PAYPAL_INTENTS = {
    CAPTURE: 'capture',
    TOKENIZE: 'tokenize',
};

export const PAYPAL_FLOW_METHOD_KEY_NAME = {
    CHECKOUT: 'createOrder',
    VAULT: 'createBillingAgreement',
};

export const PAYPAL_DEFAULT_LOCALE = 'en_US';

export const FIVERR_LOCALE_TO_PAYPAL_LOCALE = {
    'en-US': PAYPAL_DEFAULT_LOCALE,
    'de-DE': 'de_DE',
    es: 'es_ES',
    'fr-FR': 'fr_FR',
};

export const PAYPAL_BUTTON_STYLE = {
    COLOR: 'blue',
    DARK_BLUE: 'darkblue',
    SIZE: 'medium',
    TAGLINE: false,
};

export const PAYPAL_LEARN_MORE_STYLES = {
    LEFT: 'left',
    CENTER: 'center',
};

export const DEFAULT_PAYPAL_STYLE = {
    color: PAYPAL_BUTTON_STYLE.COLOR,
    size: PAYPAL_BUTTON_STYLE.SIZE,
    tagline: PAYPAL_BUTTON_STYLE.TAGLINE,
};

export const DEFAULT_PAYPAL_CREDIT_STYLE = {
    color: PAYPAL_BUTTON_STYLE.DARK_BLUE,
    size: PAYPAL_BUTTON_STYLE.SIZE,
    tagline: PAYPAL_BUTTON_STYLE.TAGLINE,
};

export const LEARN_MORE_DEFAULT_STYLE = {
    layout: 'text',
    logo: {
        type: 'none',
    },
    text: {
        color: 'grayscale',
        size: '12',
        align: 'left',
    },
};

export const LEARN_MORE_DRAWER_STYLE = {
    ...LEARN_MORE_DEFAULT_STYLE,
    text: {
        ...LEARN_MORE_DEFAULT_STYLE.text,
        align: 'center',
        size: '12',
    },
};

export const LEARN_MORE_SIDEBAR_CONTENT_STYLE = {
    ...LEARN_MORE_DEFAULT_STYLE,
    text: {
        ...LEARN_MORE_DEFAULT_STYLE.text,
        size: '14',
    },
};

export const PAYPAL_BUTTON_ELEMENT = 'paypal-button';
export const PAYPAL_LEARN_MORE_ELEMENT = 'fiverr-pp-message';

export const buttonScriptSources = () => [
    'https://js.braintreegateway.com/web/3.92.1/js/paypal-checkout.min.js',
    'https://js.braintreegateway.com/web/3.92.1/js/client.min.js',
    'https://js.braintreegateway.com/web/3.92.1/js/data-collector.min.js',
];

export const FAKE_PAYPAL_BUTTON_STYLE = {
    COLOR: 'grey',
    SIZE: 'large',
};
